export const API_END_POINT = process.env.REACT_APP_API_END_POINT;
export const API_KEY = process.env.REACT_APP_API_KEY;
